import adminCompanyApi from '../../api/admin/company'
import router from '../../router'
import {STATUS_MESSAGE} from '@/utils/notificationMessage'
import Vue from 'vue'

export const state = () => ({
  companies: [],
  detailCompany: {

  },
  totalItems: 0,
  totalPages: 0,
  editLogoCompany: {
    logo: ''
  },
  errorVendorMessage: {

  }
})

export const getter = {}

export const mutations = {
  LIST_COMPANY (state, slug) {
    state.companies = [ ...slug ]
  },
  CHANGE_TOTAL (state, slug) {
    state.totalItems = slug.total_items
    state.totalPages = slug.total_pages
  },
  CHANGE_DETAIL_COMPANY (state, slug) {
    state.detailCompany = { ...slug }
    state.editLogoCompany.logo = slug.logo
  },
  CHANGE_COMPANY (state, slug) {
    if (state.companies) {
      const tmpCompanies = [...state.companies]
      const index = tmpCompanies.findIndex(u => u.id === slug.id)
      if (tmpCompanies[index]) {
        Object.assign(tmpCompanies[index], { ...slug })
        state.companies = tmpCompanies
      }
    }
  },
  CHANGE_ERROR (state, slug) {
    state.errorVendorMessage = { ...slug }
  }
}

export const actions = {
  async getCompany ({commit}, params) {
    try {
      const res = await adminCompanyApi.getCompany(params)
      if (res.status === 200) {
        commit('LIST_COMPANY', res.data.data)
        commit('CHANGE_TOTAL', res.data.metadata)
      }
    } catch (error) {
      console.error('Get Company API error: ', error)
    }
  },
  async addCompany ({commit}, params) {
    try {
      const res = await adminCompanyApi.createCompany(params.formData)
      if (res.status === 201) {
        router.push('/admin/companies')
      }
    } catch (error) {

    }
  },
  async copyCompany ({commit}, params) {
    try {
      const res = await adminCompanyApi.copyCompany(params)
      if (res.status === 201) {}
    } catch (error) {}
  },
  async detailCompany ({commit}, params) {
    try {
      const res = await adminCompanyApi.getDetailCompany(params)
      if (res.status === 200) {
        commit('CHANGE_DETAIL_COMPANY', res.data.data)
      }
    } catch (error) {

    }
  },
  async updateCompany ({commit}, params) {
    const vm = new Vue()
    try {
      const res = await adminCompanyApi.updateCompany(params)
      if (res.status === 201) {
        commit('CHANGE_COMPANY', res.data.data)
        vm.$toastr.s(STATUS_MESSAGE.UPDATED)
        router.push(`/admin/companies/${params.id}/infor`)
      }
    } catch (error) {
      commit('CHANGE_ERROR', error.response.data.error)
    }
  },
  async deleteCompany ({commit}, params) {
    const vm = new Vue()
    try {
      const res = await adminCompanyApi.deleteCompany(params.id)
      if (res.status === 204) {
        vm.$toastr.s(STATUS_MESSAGE.DELETED)
        const resList = await adminCompanyApi.getCompany({page_index: 1})
        if (resList.status === 200) {
          commit('LIST_COMPANY', resList.data.data)
          commit('CHANGE_TOTAL', resList.data.metadata)
        }
        params.modal()
      }
    } catch (error) {

    }
  },
  async getParentCompanies ({commit}, params) {
    try {
      const res = await adminCompanyApi.getParentCompanies(params)
      if (res.status === 200) {
        commit('LIST_COMPANY', res.data.data)
      }
    } catch (error) {
      console.error('Get Company API error: ', error)
    }
  }
}

export default {
  namespaced: true,
  state,
  getter,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/admin/company.js